"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDrawer = void 0;

var Utils_1 = require("../Utils");

var Enums_1 = require("../Enums");

var ImageDrawer = /*#__PURE__*/function () {
  function ImageDrawer() {
    _classCallCheck(this, ImageDrawer);

    this.images = [];
  }

  _createClass(ImageDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "getImages",
    value: function getImages(container) {
      var containerImages = this.images.filter(function (t) {
        return t.id === container.id;
      });

      if (!containerImages.length) {
        this.images.push({
          id: container.id,
          images: []
        });
        return this.getImages(container);
      }

      return containerImages[0];
    }
  }, {
    key: "addImage",
    value: function addImage(container, image) {
      var containerImages = this.getImages(container);
      containerImages === null || containerImages === void 0 ? void 0 : containerImages.images.push(image);
    }
  }, {
    key: "init",
    value: function init(container) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, shapeOptions, idx, imageOptions, _iterator, _step, optionsImage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = container.actualOptions;
                shapeOptions = options.particles.shape;

                if (!(!Utils_1.Utils.isInArray(Enums_1.ShapeType.image, shapeOptions.type) && !Utils_1.Utils.isInArray(Enums_1.ShapeType.images, shapeOptions.type))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                idx = this.images.findIndex(function (t) {
                  return t.id === container.id;
                });

                if (idx >= 0) {
                  this.images.splice(idx, 1);
                }

                imageOptions = (_a = shapeOptions.options[Enums_1.ShapeType.images]) !== null && _a !== void 0 ? _a : shapeOptions.options[Enums_1.ShapeType.image];

                if (!(imageOptions instanceof Array)) {
                  _context.next = 27;
                  break;
                }

                _iterator = _createForOfIteratorHelper(imageOptions);
                _context.prev = 9;

                _iterator.s();

              case 11:
                if ((_step = _iterator.n()).done) {
                  _context.next = 17;
                  break;
                }

                optionsImage = _step.value;
                _context.next = 15;
                return this.loadImageShape(container, optionsImage);

              case 15:
                _context.next = 11;
                break;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](9);

                _iterator.e(_context.t0);

              case 22:
                _context.prev = 22;

                _iterator.f();

                return _context.finish(22);

              case 25:
                _context.next = 29;
                break;

              case 27:
                _context.next = 29;
                return this.loadImageShape(container, imageOptions);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 19, 22, 25]]);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.images = [];
    }
  }, {
    key: "loadImageShape",
    value: function loadImageShape(container, imageShape) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var image;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!imageShape.replaceColor) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return Utils_1.Utils.downloadSvgImage(imageShape.src);

              case 4:
                _context2.t0 = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return Utils_1.Utils.loadImage(imageShape.src);

              case 9:
                _context2.t0 = _context2.sent;

              case 10:
                image = _context2.t0;

                if (image) {
                  this.addImage(container, image);
                }

                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](0);
                console.warn("tsParticles error - ".concat(imageShape.src, " not found"));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14]]);
      }));
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b;

      if (!context) {
        return;
      }

      var image = particle.image;
      var element = (_a = image === null || image === void 0 ? void 0 : image.data) === null || _a === void 0 ? void 0 : _a.element;

      if (!element) {
        return;
      }

      var ratio = (_b = image === null || image === void 0 ? void 0 : image.ratio) !== null && _b !== void 0 ? _b : 1;
      var pos = {
        x: -radius,
        y: -radius
      };

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = opacity;
      }

      context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = 1;
      }
    }
  }]);

  return ImageDrawer;
}();

exports.ImageDrawer = ImageDrawer;